import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { userLogin } from "../../Services/api";
import { toast } from 'react-toastify';
import NodeaxiosInstance from "../../Services/nodeaxios";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import UserLogo from "../../Assets/Images/LogoUser.png"
import topBanaer from "../../Assets/Images/user_login_screen_top.png"
import UserRegister from "./userRegister";
import { useDispatch, useSelector } from "react-redux";
import { addUserToken } from "../../redux/slices/userTokenSlice";
import { useUser } from "../../Components/UserContext";


const Login = () => {
    const location = useLocation();
    const [selectedOption, setSelectedOption] = useState(location?.state?.tabName ? location.state.tabName : 'Login');
    const [isLoading, setLoadingStatus] = useState(false);
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({})
    const dispatch = useDispatch();
    const { appUser, setUser } = useUser();
    const [phoneNumber, setPhoneNumberError] = useState("");
    const [guestlogin, setGuestlogin] = useState(false)
    const navigate = useNavigate();
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const vendorUrl = localStorage.getItem("vendorUrl");


    useEffect(() => {
        serUserData(state?.userAuth?.user);
    }, [state?.userAuth?.user]);

    useEffect(() => {
        const currentUser = state?.userAuth?.user || userData;
        // An account pending verification holds a token but must not be sent
        // into the app; handleSubmit routes it to the step it stopped at.
        if (currentUser?.user_reg_status == 0) {
            return;
        }
        if (currentUser?.token && currentUser?.token !== "") {
            if (currentUser?.user_type === "User") {
                navigate('/', { replace: true });
            } else if (currentUser?.user_type === "Guest" && !location?.state?.fromGuest) {
                navigate('/search-store', { replace: true });
            }
        }
    }, [state?.userAuth?.user, userData, location?.state]);

    // Sends the user to whichever step their registration stopped at. Shared by
    // the success and error paths of login, since an unfinished signup comes
    // back as a 400.
    const resumeVerification = (details, userDate) => {
        if (details?.user_email_status == 0) {
            const pendingEmail = details?.user_email || email;
            NodeaxiosInstance.post('auth/send-email-otp', { email: pendingEmail }).catch(console.error);
            setUser({ ...(appUser || {}), user_email: pendingEmail });
            // An account that is already registered only needs the email
            // confirmed; it must not be pushed through registration or a
            // password reset.
            const flow = details?.user_reg_status == 1 ? 'loginEmailVerify' : undefined;
            navigate('/code-verification', { state: { email: pendingEmail, flow } });
            return;
        }

        // Email is already verified, only activation is outstanding.
        NodeaxiosInstance.post('auth/register-user', {})
            .then(() => {
                dispatch(addUserToken({ ...userDate, user_reg_status: 1 }));
                localStorage.setItem("login", 'logged');
                navigate(vendorUrl ? vendorUrl : '/', { replace: true });
            })
            .catch(() => {
                toast("Could not complete your registration. Please try again.", {
                    position: "bottom-center", autoClose: 3000, hideProgressBar: true,
                    theme: "light", className: 'text-danger toast-style-1'
                });
            });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setPhoneNumberError('');
        if (!guestlogin) {
            if (email == '') {
                toast("Please enter your email", {
                    position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true,
                    pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1'
                });
                return
            }
            else if (password == '') {
                toast("Please enter your password", {
                    position: "bottom-center", autoClose: 2000, hideProgressBar: true, closeOnClick: true,
                    pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: 'text-danger toast-style-1'
                });
                return
            }
            else {
                setLoadingStatus(true);
                let param = {
                    "email": email,
                    "password": password,
                };
                NodeaxiosInstance.post('auth/login', param)
                    .then((res) => {

                        if (res.status == 200) {

                            const details = res?.data?.user_details;

                            let userDate = {
                                'token': res?.data?.token,
                                'user_type': res?.data?.user_type,
                                'user_id': res?.data?.user_id,
                                'user_reg_status': details?.user_reg_status

                            };
                            dispatch(addUserToken(userDate))

                            // Email verification is mandatory, so an otherwise
                            // complete account still has to confirm it first.
                            if (details?.user_email_status == 0) {
                                setLoadingStatus(false);
                                resumeVerification(details, userDate);
                                return;
                            }

                            localStorage.setItem("login", 'logged');
                            navigate(vendorUrl ? vendorUrl : '/', { replace: true })
                            setLoadingStatus(false);
                        }
                    }, error => {
                        setLoadingStatus(false);

                        // An unfinished signup is rejected with a 400 so that
                        // clients predating the resume flow show the message
                        // instead of a bogus success. Here it is recoverable.
                        const body = error?.response?.data;

                        if (body?.code === 'REGISTRATION_INCOMPLETE') {
                            const details = body?.user_details;
                            const userDate = {
                                'token': body?.token,
                                'user_type': body?.user_type,
                                'user_id': body?.user_id,
                                'user_reg_status': details?.user_reg_status
                            };
                            dispatch(addUserToken(userDate));
                            resumeVerification(details, userDate);
                            return;
                        }

                        toast(body?.message, {
                            position: "bottom-center",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            className: 'text-danger toast-style-1'
                        });
                        return
                    });
            }
        }
    }
    const tabtoggle = (option) => {
        setSelectedOption(option);
    }

    const loginasGusest = () => {
        try {
            NodeaxiosInstance.post('auth/guest-login')
                .then((res) => {

                    if (res.status == 200) {

                        let userDate = {
                            'token': res?.data?.token,
                            'user_type': res?.data?.user_type,
                            'user_id': res?.data?.user_id
                        }
                        dispatch(addUserToken(userDate))
                        navigate('/search-store', { replace: true })
                    }

                }, error => {
                    setLoadingStatus(false);
                    toast(error?.response?.data?.message, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                    return
                });
        } catch (error) {

        }
    }

    const checkBtnDisable = () => {
        if (email == '' || password == '') {
            return true;
        }
        if (errors.password) {
            return true;
        }
        return false;
    }


    return (
        <>
            <div className="bg-white vh-100 d-flex flex-column">
                <div className="position-relative">
                    <img src={topBanaer} height="110px" width="100%" />
                    <img
                        src={UserLogo}
                        height="80px"
                        width="80px"
                        className="rounded-3 position-absolute top-100 start-50 translate-middle"
                    />
                </div>

                <>
                    <div className="tabWrapper">
                        <div className="loginOptionsList">
                            {["Login", "Register"].map((item) => (
                                <div key={item} className={`loginOptions ${selectedOption === item ? "active" : ""}`}
                                    onClick={() => { setSelectedOption(item); }}  >
                                    {item}
                                </div>
                            ))}
                            {/* <div className={`loginOptions ${selectedOption === 'Login' ? "active" : ""}`}
                                onClick={() => { setSelectedOption('Login'); }}  >
                                Login
                            </div>
                            <div className={`loginOptions ms-5 ps-4 ${selectedOption === 'Register' ? "active" : ""}`}
                                onClick={() => { setSelectedOption('Register') }}  >
                                Register
                            </div> */}
                        </div>

                    </div>
                    <div className="flex-grow-1 d-flex justify-content-start  align-items-start ">


                        <div className="userRegister w-100" style={{ maxWidth: "400px" }}>
                            {
                                selectedOption === "Login" ?
                                    <>
                                        <form className="form bg-white" onSubmit={handleSubmit}>
                                            <div className='ff-poppins-regular fs-12 '>Email <span className="text-danger">*</span></div>
                                            <input type="email" className="w-100 ff-poppins-medium fs-20" name="user_email"
                                                maxLength={45}
                                                value={email}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.target.blur();
                                                    }
                                                }}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            {errors.user_email && (
                                                <div className="input-inline-error">{errors.user_email}</div>
                                            )}

                                            <div className='ff-poppins-regular fs-12 mt-2 pt-1'>
                                                Password <span className="text-danger">*</span>
                                            </div>
                                            <div style={{ position: "relative" }}>
                                                <input type={showPassword ? "text" : "password"}
                                                    className="w-100 ff-poppins-medium fs-20 pe-5" name="password" maxLength={45}
                                                    value={password}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.target.blur();
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        let input = e.target.value;

                                                        if (input.length > 20) return;

                                                        let error = "";

                                                        if (input.length > 0 && input.length < 8) {
                                                            error = "Minimum 8 characters";
                                                        } else if (!/[A-Z]/.test(input)) {
                                                            error = "Must contain uppercase";
                                                        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(input)) {
                                                            error = "Must contain special character";
                                                        }
                                                        setPassword(input)
                                                        setErrors(prev => ({
                                                            ...prev,
                                                            password: error
                                                        }));

                                                    }
                                                    }
                                                />

                                                <span onClick={() => setShowPassword(!showPassword)}
                                                    style={{ position: "absolute", right: "9px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}  >
                                                    {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                                                </span>
                                            </div>

                                            {errors.password && (
                                                <div className="input-inline-error">{errors.password}</div>
                                            )}

                                            <div className="fs-11 ff-poppins-semiBold primary-text d-flex justify-content-between mt-2">
                                                <span onClick={() => navigate('/login-With-Number')}>Login with OTP instead</span>
                                                <span onClick={() => navigate('/forgot-password')}>Forgot password?</span>
                                            </div>


                                            <div className="d-flex justify-content-center">
                                                <button disabled={checkBtnDisable()} type="submit"
                                                    className={`${isLoading ? "loading" : ""} ${(email == '' || password == '') || errors.password ? "opacity-40" : ""}  w-100 border-0 primary-bg rounded-pill ff-poppins-semiBold fs-18 
                                                text-white mt-4 mb-2 d-flex justify-content-center align-items-center`
                                                    }>
                                                    {
                                                        isLoading ? <span className="loader-style-1"></span> : <span>Login</span>
                                                    }
                                                </button>
                                            </div>


                                            <div className="text-center fs-12 ff-poppins-medium mt-1" onClick={() => tabtoggle("Register")}>
                                                Don't have an account?
                                                <span className="primary-text ms-1">Register.</span>
                                            </div>

                                            {
                                                userData?.user_type != "Guest" &&
                                                <>
                                                    <span className="d-flex justify-content-center fs-12 ff-poppins-medium mt-3">------ OR ------</span>
                                                    <div className="d-flex justify-content-center mt-2" onClick={() => { setGuestlogin(true); loginasGusest(); }} >
                                                        <button type="submit"
                                                            className="primary-bg w-100 border-0 rounded-pill ff-poppins-semiBold fs-18 text-white mt-1 d-flex justify-content-center align-items-center">
                                                            Login as Guest
                                                        </button>
                                                    </div>
                                                </>
                                            }


                                        </form>
                                    </>
                                    : selectedOption === "Register" ?
                                        <UserRegister tabtoggle={tabtoggle} />
                                        : ""
                            }
                        </div>
                    </div>


                </>
            </div >
        </>
    )
};

export default Login;


{/* <div className="w-100 mb-5 ">
                                        <div className=" ff-poppins-medium">
                                            <label className="ff-poppins-regular fs-12 mt-2 pt-1">Email</label>
                                            <input type="email" value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                className="form-control rounded-0 border-0  fs-20 secondary-text no-spinners"  />
                                        </div>
                                        <div className=" ff-poppins-medium mt-3"> 
                                            <label className="ff-poppins-regular fs-12 mt-2 pt-1">Password</label>
                                            <div style={{ position: "relative" }}>
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control rounded-0 border-0  fs-20  secondary-text no-spinners w-100 ff-poppins-medium  "
                                                    name="password" 
                                                    maxLength={45}
                                                    value={password}
                                                    onChange={(e) => {
                                                        let input = e.target.value;

                                                        if (input.length > 20) return;

                                                        let error = "";

                                                        if (input.length > 0 && input.length < 8) {
                                                            error = "Minimum 8 characters";
                                                        } else if (!/[A-Z]/.test(input)) {
                                                            error = "Must contain uppercase";
                                                        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(input)) {
                                                            error = "Must contain special character";
                                                        }
                                                        setPassword(input)
                                                        setErrors(prev => ({
                                                            ...prev,
                                                            password: error
                                                        }));
                                                    }
                                                    }
                                                />

                                                <span onClick={() => setShowPassword(!showPassword)}
                                                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }} >
                                                    {showPassword ? <AiOutlineEyeInvisible size={20} /> : <AiOutlineEye size={20} />}
                                                </span>
                                            </div> 

                                            <div className="fs-11 ff-poppins-semiBold primary-text d-flex justify-content-between mt-2">
                                                <span onClick={() => navigate('/login-With-Number')}>Login with OTP instead</span>
                                                <span onClick={() => navigate('/forgot-password')}>Forgot password ?</span>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <button type="submit" onClick={loginWithPhoneNumber}
                                                className={(isLoading ? "loading" : "") + " " + `primary-bg w-100 border-0 rounded-pill ff-poppins-semiBold fs-20 text-white mt-5 d-flex justify-content-center align-items-center`}>
                                                {
                                                    isLoading ?
                                                        <span className="loader-style-1"></span>
                                                        :
                                                        <span>Login</span>
                                                }
                                            </button>
                                        </div> 

                                        <div className="d-flex justify-content-center mt-3">
                                <button type="submit" onClick={loginWithPhoneNumber}
                                    className="primary-bg w-100 border-0 rounded-pill ff-poppins-semiBold fs-20 text-white mt-1 d-flex justify-content-center align-items-center">
                                    Login as Guest
                                </button>
                            </div> 
                       
                                    </div> */}

